import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { companyQuery } from "#modules/company/infra/company.query";
import { updateCompany } from "#modules/company/infra/updateCompany.api";
import { OnboardingActivityTypeType } from "shared";

export const useUpdateOnboardingActivityType = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: (onboardingActivityType: OnboardingActivityTypeType) =>
      updateCompany({ onboardingActivityType }),
    onSuccess: () => {
      void queryClient.invalidateQueries(companyQuery());
    },
    onError: (err) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { updateOnboardingActivityType: mutate, ...rest };
};
